var processInclude = require('base/util');

processInclude(require('./geolocation/redirectByGeolocation'));
